import { IconSettings } from "@tabler/icons-react"

export default function SettingsPage() {
  return (
    <div className="flex flex-col gap-4 py-4 md:gap-6 md:py-6 px-4 lg:px-6">
      <div className="flex items-center gap-2">
        <IconSettings className="size-6" />
        <h1 className="text-2xl font-bold">Settings</h1>
      </div>
      <p className="text-muted-foreground">
        Manage your account preferences and application settings.
      </p>
      <div className="flex flex-col gap-4 max-w-xl">
        <div className="rounded-xl border bg-card p-6">
          <h3 className="font-semibold">Profile</h3>
          <p className="text-sm text-muted-foreground mt-1">Update your display name and notification preferences.</p>
        </div>
        <div className="rounded-xl border bg-card p-6">
          <h3 className="font-semibold">Appearance</h3>
          <p className="text-sm text-muted-foreground mt-1">Toggle between light and dark themes.</p>
        </div>
      </div>
    </div>
  )
}
